module.exports = __webpack_public_path__ + "static/img/06.ce27149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/06.png
// module id = Xe6W
// module chunks = 1